import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";
import { reducerPaths } from "../../app/reducerPaths";

export const dashboardReportApi = createApi({
  reducerPath: reducerPaths.dashboardReportApi,
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getDashboardReport: builder.query({
      query: ({ params }) => {
        return {
          url: `/dealer/dashboard_report`,
          method: "GET",
          params   
        }
      }
    }),
  }),
});

export const { 
  useGetDashboardReportQuery,
  useLazyGetDashboardReportQuery
} = dashboardReportApi;